module.exports = __webpack_public_path__ + "img/search.8d2a4c05.gif";